<div class="card">
    <div class="card-header">
        Site Geo Mapping
        <!-- <div style="text-align: center" class="mb-1">
            <img [src]="user.CompanyLogo" alt="Company Logo" />
        </div> -->
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Branch <span class="text-danger">*</span></label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client');Clear()"
                    placeholder="Select Branch">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Client <span class="text-danger">*</span></label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site');Clear()" placeholder="Select Client">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site');Clear()" placeholder="Select Site">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-3 px-1"><br>
                <button class="btn btn-sm btn-primary" name="submit" (click)="add()">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">
                                <input mdbCheckbox class="form-check-input" style="height: 15px; width: 15px;"
                                    name="header" type="checkbox" (change)="toggleSelectAllRows()"
                                    [checked]="selectAllRows" value="" />
                            </th>
                            <th scope="col" *ngIf="this.common.PageRight.IsPrint">QR Code</th>
                            <th scope="col" style="width: 130px; ">Branch Name</th>
                            <th scope="col" style="width: 130px;">Client Name</th>
                            <th scope="col" style="display: none;">Site ID</th>
                            <th scope="col" style="width: 100px;">Site Code</th>
                            <th scope="col" style="width: 180px;">Site Name</th>
                            <th scope="col">Latitude </th>
                            <th scope="col">Longitude </th>
                            <th scope="col" style="width: 150px;">Radius (meter)</th>
                            <th scope="col">IsAltitudeApplicable</th>
                            <th scope="col" style="width: 150px;">Altitude (feet)</th>
                            <th scope="col" style="width: 150px;">Altitude Radius (feet)</th>
                            <th scope="col" style="width: 150px;">Accuracy</th>
                            <th scope="col">Heading</th>
                            

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let shift of SiteGeoMapping; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>
                                <input mdbCheckbox class="form-check-input" name="row"
                                    style="height: 13px; width: 13px;" type="checkbox" [(ngModel)]="shift.checked"
                                    (change)="toggleRowEnabled(i)" value="" />
                            </td>
                            <td *ngIf="this.common.PageRight.IsPrint">
                                <button class="btn btn-primary btn-lg no-style-button"
                                    (click)="generateQRCodeAndDownloadPDF(shift)">
                                    <img src="assets/QRdownload.png" alt="QR Icon" class="btn-icon" heigth="20"
                                        width="25" />
                                </button>
                            </td>
                            <td>{{ shift.BranchName }}</td>
                            <td>
                                <div style="width: 100px">
                                    {{ shift.ClientName }}
                                </div>
                            </td>
                            <td style="display: none;">{{ shift.SiteID }}</td>
                            <td>{{ shift.SiteCode }}</td>
                            <td>{{ shift.SiteName }}</td>
                            <td>
                                <div style="width: 150px">
                                    <input name="latitude" placeholder="0" class="form-control" type="number"
                                        [(ngModel)]="shift.Latitude" [disabled]="!rowEnabled[i]"
                                        (keypress)="ValidateInput($event, 'Latitude')" (paste)="onPaste($event)" />
                                </div>
                            </td>
                            <td>
                                <div style="width: 150px">
                                    <input name="longitude" placeholder="0" class="form-control" type="number"
                                        [(ngModel)]="shift.Longitude" [disabled]="!rowEnabled[i]"
                                        (keypress)="ValidateInput($event, 'Latitude')" (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td>
                                <div style="width: 150px">
                                    <input name="radius" type="number" class="form-control" [(ngModel)]="shift.Radius"
                                        [disabled]="!rowEnabled[i]" (keypress)="ValidateInput($event, 'radius')" min="0"
                                        (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td style="text-align: center;">
                                <input mdbCheckbox class="form-check-input" name="isaltitudeapplicable{{i}}"
                                    [disabled]="!rowEnabled[i]"
                                    style="height: 13px; width: 13px;" type="checkbox" [(ngModel)]="shift.IsAltitudeApplicable"
                                    value="" />
                            </td>
                            
                            <td>
                                <div style="width: 150px">
                                    <input name="altitude" class="form-control" [(ngModel)]="shift.Altitude"
                                        [disabled]="disableAltitude(rowEnabled[i], shift.IsAltitudeApplicable)" type="number"
                                        (keypress)="ValidateInput($event, 'NumandDec')" (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td>
                                <div style="width: 150px">
                                    <input name="altituderadius" type="number" class="form-control" [(ngModel)]="shift.AltitudeRadius"
                                        [disabled]="disableAltitude(rowEnabled[i], shift.IsAltitudeApplicable)" (keypress)="ValidateInput($event, 'radius')" min="0"
                                        (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td>
                                <div style="width: 150px">
                                    <input name="accuracy" class="form-control" [(ngModel)]="shift.Accuracy"
                                        [disabled]="!rowEnabled[i]" type="number"
                                        (keypress)="ValidateInput($event, 'NumandDec')" (paste)="onPaste($event)" />
                                </div>
                            </td>
                            <td>
                                <div style="width: 150px">
                                    <input name="heading" type="number" class="form-control" [(ngModel)]="shift.Heading"
                                        [disabled]="!rowEnabled[i]" (keypress)="ValidateInput($event, 'NumandDec')"
                                        (paste)="onPaste($event)" />
                                </div>
                            </td>

                            
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                    (click)="generateQRCodeAndDownloadPDF(null)">
                    <i class="bi bi-qr-code" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'QR Code':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                    (click)="exportToExcel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button class="btn btn-sm btn-primary" name="sample" (click)="downloadExcel()">
                    <i class="bi bi-file-earmark-excel-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Sample':'Loading...'}}
                </button>
                &nbsp;&nbsp;
                <label for="file-upload" class="btn btn-sm btn-primary">
                    <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                </label>
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                    accept=".xls,.xlsx">
                &nbsp;&nbsp;
                <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary" name="save"
                    (click)="save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>